<app-intro-section></app-intro-section>
<app-ai-assistant></app-ai-assistant>
@for (card of cards; track card.id) {
  <app-pyg-x-card [imageFile]="'PygmaliosX'" [data]="card"></app-pyg-x-card>
}
<app-benefits></app-benefits>
